module.exports = __webpack_public_path__ + "static/media/sql.23d4cff3.png";